__turbopack_context__.v({
  "Content": "page-module__feV5qq__Content",
  "FeatureName": "page-module__feV5qq__FeatureName",
  "Header": "page-module__feV5qq__Header",
  "Page": "page-module__feV5qq__Page",
  "Sider": "page-module__feV5qq__Sider",
  "SubHeader": "page-module__feV5qq__SubHeader",
  "toggleButton": "page-module__feV5qq__toggleButton",
  "toggleButtonCollapsed": "page-module__feV5qq__toggleButtonCollapsed",
});
